import { useState } from "react";

import iCircleBlue from "../../assets/images/100-circle-blue.svg";
import iCircleComments from "../../assets/images/100-circle-comments.svg";
import iCircleDown from "../../assets/images/100-circle-down.svg";
import iDot from "../../assets/images/100-circle-gray.svg";
import iPlus from "../../assets/images/100-circle-plus.svg";
import iCircleUp from "../../assets/images/100-circle-up.svg";
import iEdit from "../../assets/images/100-edit.svg";
import iPin from "../../assets/images/100-pin.svg";
import iReply from "../../assets/images/100-reply-gray.svg";
import iTrash from "../../assets/images/100-trash.svg";
import avatar4 from "../../assets/images/avatar2.png";
import CurrentMeetingUsersStatusBar from "../lw-widget/current-meeting-actions-and-details/current-meeting-users-status-bar";

import NewComment from "./NewComment";
import SingleReply from "./SingleReply";

const FSComments = () => {
  const [showComments, setShowComments] = useState(true);
  const [showAllReplies, setShowAllReplies] = useState(false);
  return (
    <div className="flex m-t-10">
      <div className="flex-col">
        <div onClick={() => setShowComments(!showComments)}> Show/Hide Comments</div>
        {showComments && (
          <>
            <div className="fg-fs-comment-container">
              <section className="fg-fs-comments">
                {!showAllReplies && (
                  <div className="fg-fs-single-comment">
                    <div className="align-center">
                      <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                      <div className="B2-SemiBold fg-text-white"> Mark</div>
                      <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                      <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                      <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                      <img alt="" src={iPin} width={12} height={12} className="m-r-2" />
                      <div className="C1-Medium fg-text-gray-light"> 1:35</div>
                    </div>
                    <div className="w-280 B3-Regular fg-text-white p-t-6 p-b-4">Lorem ipsum dolor sit amet consectetur adipisicing elit.</div>
                  </div>
                )}
                <div className="countReplys w-280">
                  <span className="C1-Medium m-lr-12"> 15 Replies </span>
                </div>
                <div className="fg-fs-replies">
                  <div className="fg-fs-single-comment">
                    <div className="align-center space-between w-280">
                      <div className="align-center">
                        <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                        <div className="B2-SemiBold fg-text-white"> Mark</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                        <img alt="" src={iCircleBlue} width={8} height={8} className="m-lr-8" />
                      </div>
                      <div>
                        <img alt="" src={iEdit} width={16} height={16} className="pointer m-r-10" />
                        <img alt="" src={iTrash} width={16} height={16} className="pointer" />
                      </div>
                    </div>
                    <div className="w-280 B3-Regular fg-text-white p-t-6 p-b-4">Reply1 Reply1 Reply1 Reply1 Reply1</div>
                  </div>
                </div>
                {!showAllReplies ? (
                  <div className="button button-sm button-r button-dk w-280" onClick={() => setShowAllReplies(true)}>
                    Show 14 Replies
                  </div>
                ) : (
                  <div className="fg-fs-replies">
                    {Array.from(Array(10)).map(() => (
                      <SingleReply />
                    ))}
                  </div>
                )}

                <div className="fg-fs-replies">
                  <SingleReply />
                  <SingleReply />
                </div>
              </section>
              {!showAllReplies && (
                <div className="w-280">
                  <span className="B2-SemiBold fg-text-white"> Add New Reply </span>
                  {/* <input
                    type="text"
                    className="fg sm dark-mode w-280"
                    placeholder="add your reply..."
                  /> */}
                  <textarea className="fg dark-mode w-280" placeholder="Lorem Ipsum is simply dummy text of" rows="2" />
                  <div className="flex-end">
                    <div className="button button-sm button-bk button-r m-r-5">Cancel</div>
                    <div className="button button-sm button-dk button-r w-54">Send</div>
                  </div>
                </div>
              )}
            </div>
            <div className="fg-fs-comment-container inactive">
              <section className="fg-fs-comments">
                <div className="fg-fs-single-comment">
                  <div className="align-center">
                    <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                    <div className="B2-SemiBold fg-text-white"> Mark</div>
                    <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                    <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                    <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                    <img alt="" src={iPin} width={12} height={12} className="m-r-2" />
                    <div className="C1-Medium fg-text-gray-light"> 1:35</div>
                  </div>
                  <div className="w-280 B3-Regular fg-text-white p-t-6 p-b-4">
                    {`${Math.random().toString(36).slice(2, 120)} `.repeat((Math.random() * 10).toFixed())}
                  </div>
                </div>
                <div className="align-center m-t-6">
                  <img alt="" src={iReply} width={16} height={16} />
                  <span className="C1-Medium fg-text-gray-light3 m-lr-6 pointer">View 14 Replies</span>
                  <img alt="" src={iCircleBlue} width={8} height={8} />
                </div>
              </section>
            </div>
          </>
        )}
      </div>
      <NewComment />
      <div className="relative">
        <CurrentMeetingUsersStatusBar count={6} />
      </div>
      <div className="relative">
        <CurrentMeetingUsersStatusBar darkMode />
      </div>
      <div className="fg-fs-comments-controller dark-mode relative">
        <div className="flex dark-mode">
          <img alt="" src={iCircleComments} width={44} height={44} className="pointer" />
          <div className="badge black auto blue absolute left-30"> 10</div>
        </div>
        <div className="divider-vertical h-8" />
        <div className="justify-content-center">
          <img alt="" src={iPlus} width={24} height={24} className="pointer" />
        </div>
        <div className="divider-vertical h-8" />
        <div className="justify-content-center">
          <img alt="" src={iCircleUp} width={24} height={24} className="i i-circle-up" />
        </div>
        <div className="divider-vertical h-8" />
        <div className="justify-content-center">
          <img alt="" src={iCircleDown} width={24} height={24} className="i i-circle-down" />
        </div>
      </div>
    </div>
  );
};

export default FSComments;
